import { faEye, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-form-role',
  template: `
    <form>
      <div class="row">
        <div class="col-md-12">
          <form [formGroup]="roleForm" (ngSubmit)="saveRole()">
            <div class="form-group required mb-4 mt-3">
              <label for="name" class="form-label ms-2">Nombre del role</label>
              <input type="text" class="form-control form-control-lg rounded-3" id="name" placeholder="" formControlName="name">
              <div *ngIf="ufc['name'].touched && ufc['name'].invalid">
                <div *ngIf="ufc['name'].errors?.['required']" class="text-danger text-sm">El nombre es requerido.</div>
              </div>
            </div>
            <div class="form-group required mb-4 mt-3" *ngIf="role">
              <label for="name" class="form-label ms-2">Grupo</label>
              <input type="text" class="form-control form-control-lg rounded-3" id="name" placeholder="" [value]="roleGroup" readonly>
              <!-- div *ngIf="ufc['name'].touched && ufc['name'].invalid">
                <div *ngIf="ufc['name'].errors?.['required']" class="text-danger text-sm">El nombre es requerido.</div>
              </!-->
            </div>

            <div class="form-group required mb-4 mt-3" *ngIf="!role">
              <label for="name" class="form-label ms-2">Grupo</label>
              <select class="form-select form-select-lg" (change)="selectGroup($event)">
                <option value="0">Selecciona un grupo</option>
                <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
              </select>
            </div>
            <div class="list-group border-0">
              <div *ngFor="let group of groupedPermissions | keyvalue">
                <table class="table table-responsive">
                  <tbody>
                    <tr>
                    <th colspan="4" class="text-capitalize mt-2 ms-2">{{ group.key }}</th>
                      <td colspan="1" style="width: 108px;" *ngFor="let permission of group.value">
                        <div class="form-check form-switch mt-2 ps-3">
                          <input class="form-check-input form-check-input-lg float-end me-3" type="checkbox" [checked]="permission.active" (change)="updatePermission(permission, $event)">
                          <label class="form-check-label" for="flexCheckDefault">
                            <fa-icon [icon]="icons.faEdit" *ngIf="permission?.tipo==='edit'"></fa-icon>
                            <fa-icon [icon]="icons.faEye" *ngIf="permission?.tipo==='read'"></fa-icon>
                            <fa-icon [icon]="icons.faTrashAlt" *ngIf="permission?.tipo==='delete'"></fa-icon>
                            <fa-icon [icon]="icons.faPlus" *ngIf="permission?.tipo==='create'"></fa-icon>
                          </label>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="form-group required mb-4 mt-3 text-end">
              <button type="button" class="btn btn-link me-2" routerLink="/roles">Cancelar</button>
              <button type="submit" class="btn btn-zazz-dark">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </form>
  `,
  styleUrls: []
})
export class FormRoleComponent implements OnInit {

  @Input() role: any;
  @Output() roleData = new EventEmitter<any>();

  roleForm: FormGroup = new FormGroup({});
  loading: boolean = false;

  roleGroup: string = "";
  group_id: number = 0;

  groups: any[] = [
    { id: 1, name: 'Administrador' },
    { id: 2, name: 'Técnico' },
    { id: 3, name: 'Inquilino' },
  ];

  permissions: any = {};
  groupedPermissions: { [key: string]: any[] } = {};


  constructor(
    private fb: FormBuilder,
    private route: Router,
    private toastr: ToastrService,
    private store: SettlementsService,
    private activateRoute: ActivatedRoute,
    public icons: IconsService,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.roleForm = this.fb.group({
      name: ['', Validators.required],
      group_id: ['', Validators.required],
      permissions: [[], Validators.required]
    });
  }

  loadPermissions() {
    this.store.getPermissions({ page: 1, per_page: 1000}).subscribe({
      next: (response: any) => {
        let permits: any[] = [];
        if (!this.role) {        
          response.data.map((item: any) => {
            permits.push({
              id: item.id,
              name: item.name,
              group: item.group,
              tipo: item.tipo,
              sub_group: item.sub_group,
              active: false
            });
          });
        } else {
          console.log('permissions => ', response);
          response.data.map((item: any) => {
            permits.push({
              id: item.id,
              name: item.name,
              group: item.group,
              tipo: item.tipo,
              sub_group: item.sub_group,
              active: this.roleForm.value.permissions.find((p: any) => p === item.name) ? true : false
            });
          });
        }

        this.permissions = permits;
        this.groupPermissions();
        this.roleForm.patchValue({ permissions: this.permissions });
      }, error: (error: any) => {
        console.error('error => ', error);

      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['role'].currentValue) {
      this.roleForm.patchValue(changes['role'].currentValue);
      this.roleGroup = this.groups.find(g => g.id === changes['role'].currentValue.group_id)?.name;
      this.group_id = changes['role'].currentValue.group_id;
      if (changes['role'].currentValue.permissions) {        
        const permissionsArray = JSON.parse(changes['role'].currentValue?.permissions.replace(/'/g, '"'));        
        this.roleForm.patchValue({ permissions: permissionsArray });
        this.loadPermissions();
      }
    }
  }

  groupPermissions() {
    this.groupedPermissions = this.permissions.reduce((groups: any, permission: any) => {
      const group = permission.sub_group || 'Others';
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(permission);
      return groups;
    }, {});

    for (const group in this.groupedPermissions) {
      this.groupedPermissions[group].sort((a: any, b: any) => a.tipo.localeCompare(b.tipo));
    }
  }

  updatePermission(permission: any, event: any) {
    permission.active = event.target.checked;
  }

  updateMenu(e: any) {
    this.permissions.menu[e.target.value] = e.target.checked;
  }

  updatePermissions(e: any) {
    if (e.target.value.split('.').length > 0) {
      let module_action: any = e.target.value.split('.');
      let target_action: any = e.target.id.split('.');

      if (e.target.id.split('.').length == 2) {
        this.permissions.modules[module_action[0]][target_action[0]][target_action[1]][module_action[1]] = e.target.checked;
      } else {
        this.permissions.modules[module_action[0]][e.target.id][module_action[1]] = e.target.checked;
      }

      return;
    } else {
      this.permissions.modules[e.target.value][e.target.id] = e.target.checked;
    }
  }

  selectGroup(e: any) {
    this.roleForm.patchValue({ group_id: e.target.value });
  }

  get ufc() {
    return this.roleForm.controls;
  }

  saveRole() {
    this.loading = true;
    const filteredArray = this.permissions.filter((item: any) => item.active);

    this.roleForm.patchValue({
      permissions: filteredArray.map((item: any) => item.name)
    });

    if (this.roleForm.invalid) {
      this.toastr.error('Faltan datos por completar.');
      this.loading = false;
      this.roleForm.markAllAsTouched();
      return;
    }

    const payload: any = {
      name: this.roleForm.value.name,
      group_id: this.roleForm.value.group_id,
      permissions: JSON.stringify(this.roleForm.value.permissions)
    };

    this.roleData.emit(payload);
  }

}
